import React, { FC } from 'react'
import { Layout } from 'components/Layout'
import { BalanceTemplate } from 'components/Templates'

const Balance: FC = () => {
  return (
    <Layout headline={'銀行振込'} iconPath={'/icon/white/revenue.svg'} title={'銀行振込'}>
      <BalanceTemplate />
    </Layout>
  )
}

export default Balance
